















import Vue from 'vue'
import Component from "vue-class-component";
import { Icon } from 'vant';
Vue.use(Icon);
@Component
export default class VideoList extends Vue {
    videoList=[
        {
            videoImg:'http://yths.zgftlm.com/static/videoImg2021062501.png',
            videoUrl:'http://yths.zgftlm.com/static/养生诀窍.mp4',
            man:'王建新',
            title:'养生诀窍',
            date:'2021-06-25',
            type:'video'
        },
        {
            videoImg:'http://yths.zgftlm.com/static/videoImg2021062502.png',
            videoUrl:'http://yths.zgftlm.com/static/终老养生经.mp4',
            man:'王建新',
            title:'终老养生经',
            date:'2021-06-25',
            type:'video'
        },
        {
            videoImg:'http://yths.zgftlm.com/static/videoImg5.jpeg',
            url:'https://mp.weixin.qq.com/s/llcufVn9MXS6-Jg8-aRbow',
            man:'王建新',
            title:'健康达人的幸福生活--王建新讲“茶疗”',
            date:'2020-12-10',
            type:'text'
        },
        {
            videoImg:'http://yths.zgftlm.com/static/videoImg4.jpeg',
            url:'https://mp.weixin.qq.com/s/Zl-9g1fcgaEdSYqB2rmJZg',
            man:'王建新',
            title:'清华大学出的新三字经，非常经典！',
            date:'2020-10-28',
            type:'text'
        },
        {
            videoImg:'http://yths.zgftlm.com/static/videoImg1.jpeg',
            videoUrl:'http://yths.zgftlm.com/static/video1.mp4',
            man:'王建新',
            title:'中华艺术家传承系列主题论坛 —— 王建新书法讲解',
            date:'2020-09-09',
            type:'video'
        },
        {
            videoImg:'http://yths.zgftlm.com/static/videoImg2.jpeg',
            videoUrl:'http://yths.zgftlm.com/static/video2.mp4',
            man:'王建新',
            title:'“名家、名作、名品”系列主题论坛',
            date:'2020-09-09',
            type:'video'
        },
        {
            videoImg:'http://yths.zgftlm.com/static/videoImg3.jpeg',
            url:'https://mp.weixin.qq.com/s/j6cizXy4HDjC17Hs7-_yLg',
            man:'王建新',
            title:'“名家、名作、名品”系列主题论坛在太原 隆重召开',
            date:'2020-09-09',
            type:'text'
        }
    ]

    goVideo(item:any){
        if(item.type=='video'){
        this.$router.push({path:'/video',query:{videoUrl:item.videoUrl}})

        }else{
            window.location.href=item.url
        }
        // console.log(item)
    }
}
